/**
 * HLF Mobile Bottom Toolbar Logic
 */

document.addEventListener('DOMContentLoaded', () => {
  const accountLabel = document.getElementById('hlf-toolbar-account-label');
  const accountLink = document.getElementById('hlf-toolbar-account');

  // Function to switch toolbar to logged-in state
  function autoLoginToolbar() {
    if (accountLabel) {
      accountLabel.textContent = 'Account';
    }
    if (accountLink) {
      // If we know user is logged in, optionally point directly to /account
      accountLink.setAttribute('href', '/account');
      accountLink.removeAttribute('onclick');
    }
  }

  // 1. Check for Kwikpass user token on load
  const userToken = localStorage.getItem('KWIKSESSIONTOKEN');
  if (userToken) {
    autoLoginToolbar();
  }

  // 2. Listen for custom user-loggedin event (if triggered by any 3rd-party auth)
  window.addEventListener('user-loggedin', function (event) {
    const token = event?.detail?.token;
    if (token) {
      autoLoginToolbar();
    }
  });
  
  // 3. Optional: Set active state based on current pathname
  const path = window.location.pathname;
  const toolbarItems = document.querySelectorAll('.hlf-toolbar-item:not(.hlf-center-cta):not(.hlf-app-tab)');
  
  toolbarItems.forEach(item => {
    const href = item.getAttribute('href');
    if (href === path || (href !== '/' && path.startsWith(href))) {
      item.classList.add('active');
    } else {
      item.classList.remove('active');
    }
  });

  // If path is root, make sure Home is active
  if (path === '/') {
    const homeTab = document.querySelector('.hlf-toolbar-item[href="/"]');
    if (homeTab) homeTab.classList.add('active');
  }
});
